define('app/views/defaultAnalytics/retail',[], function () {
  return {
    requestGCSelectionItemClick: function (
      giftCertificates,
      packageCertificates,
      itemId
    ) {

      var allGiftItems = [].concat(packageCertificates, giftCertificates);
      var selectedItem = _.find(allGiftItems, function (item) {
        return item.ItemId == itemId;
      });
      if(selectedItem){
        gtag("event", "view_item", {
          currency: app.customization.currencyCode,
          value: +selectedItem.Price,
          items: [
            {
              item_id: selectedItem.ItemId,
              item_name: selectedItem.Name,
              affiliation: app.localization.siteName,
              item_category: selectedItem.ItemCategory,
              item_category2: selectedItem.ItemSubcategory,
              price: +selectedItem.Price,
              item_variant: selectedItem.ItemType,
              quantity: 1,
            }
          ],
        });
      }
    },
    requestGCSelectionCatClick: function (
      giftCertificates,
      packageCertificates,
      category
    ) {
      console.log(
        "requestGCSelectionCatClick",
        giftCertificates,
        packageCertificates,
        category
      );
      var allGiftItems = [].concat(packageCertificates, giftCertificates);
      var selectedCatItems = _.filter(allGiftItems, function (item) {
        return item.ItemType == category;
      });

      if(selectedCatItems.length > 0){
        gtag("event", "view_item_list", {
          item_list_id: "Gift-" + category,
          item_list_name: "Gift items in " + category,
          items: _.map(selectedCatItems, function (retailItem) {
            return {
              item_id: retailItem.ItemId,
              item_name: retailItem.Name,
              affiliation: app.localization.siteName,
              item_category: retailItem.ItemCategory,
              item_category2: retailItem.ItemSubcategory,
              price: +retailItem.Price,
              item_variant: retailItem.ItemType,
              quantity: 1,
            };
          }),
        });
      }
    },
  };
});

